import { useAuth } from "@base-identity/react";
import { useEffect, type ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch } from "@/hooks/storeHooks";
import { clearState, setUser } from "@/store/reducers/userSlice";
import { loadZooozProfile, ProfileCompletionRequiredError, profileCompletionPath } from "./identity";

export function IdentityBootstrap({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.status === "signed_out") {
      dispatch(clearState());
      return;
    }
    if (!auth.isSignedIn || !auth.userId) return;
    if (/^\/(login|signup|oauth|logout)(?:\/|$)/.test(location.pathname)) return;
    let active = true;
    void loadZooozProfile()
      .then((user) => { if (active) dispatch(setUser(user)); })
      .catch((cause) => {
        if (active && cause instanceof ProfileCompletionRequiredError) {
          dispatch(clearState());
          navigate(profileCompletionPath(location.pathname + location.search), { replace: true });
        }
      });
    return () => { active = false; };
  }, [auth.isSignedIn, auth.status, auth.userId, auth.sessionId, dispatch, location.pathname, location.search, navigate]);

  return <>{children}</>;
}
